import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = (theme) => ({
  paddingLeft: { sm: 2 },
  paddingRight: { xs: 1, sm: 1 },
  backgroundColor: theme.palette.primary.main,
});

const text: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.light,
  fontSize: theme.spacing(3),
  fontWeight: 600,
});

const styles = {
  container,
  text,
};

export default styles;
